import React from "react";
import { Dumbbell } from "lucide-react";

/**
 * Minimal centered loader. Used during app boot, login, page transitions.
 * Green accent matches Fitnudge primary.
 */
export default function Loading({ label = "Loading…", testId = "app-loading" }) {
  return (
    <div
      data-testid={testId}
      className="min-h-[60vh] w-full flex flex-col items-center justify-center gap-4"
    >
      <div className="relative">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <Dumbbell className="w-5 h-5 text-primary animate-pulse" strokeWidth={2.4} />
        </div>
        <span className="absolute inset-0 rounded-xl ring-2 ring-primary/30 animate-ping" />
      </div>
      <p className="text-xs font-medium text-muted-foreground tracking-wide">{label}</p>
    </div>
  );
}
